var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"sidebar","mode":"out-in"}},[(_vm.isChargingpointSelected && _vm.isPlanningAlternativeLocation)?_c('ActionSidebarSearch'):(_vm.isChargingpointSelected && ! _vm.isPlanningAlternativeLocation)?_c('ActionSidebar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }